// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"video-embed_videoWrapper__brOJL","playIcon":"video-embed_playIcon__jTJyF"};